// extracted by mini-css-extract-plugin
export default {"tupacGrid":"oj-z","tupacHeader":"pj-z","tupacHeader2":"qj-z","tupacMenu":"rj-z","tupacMenu2":"sj-z","tupacMain":"tj-z","tupacMain2":"uj-z"};